import React from 'react';
import { motion } from 'framer-motion';
import { HeartPulseIcon, LandmarkIcon, ShoppingBagIcon, FactoryIcon, Building2Icon, MonitorSmartphoneIcon, GraduationCapIcon, TruckIcon } from 'lucide-react';
import { useLanguage } from '../LanguageContext';
const getIndustries = (t: any) => [{
  name: t('ind_1'),
  icon: HeartPulseIcon
}, {
  name: t('ind_2'),
  icon: LandmarkIcon
}, {
  name: t('ind_3'),
  icon: ShoppingBagIcon
}, {
  name: t('ind_4'),
  icon: FactoryIcon
}, {
  name: t('ind_5'),
  icon: Building2Icon
}, {
  name: t('ind_6'),
  icon: MonitorSmartphoneIcon
}, {
  name: t('ind_7'),
  icon: GraduationCapIcon
}, {
  name: t('ind_8'),
  icon: TruckIcon
}];
export function Industries() {
  const {
    t
  } = useLanguage();
  const industries = getIndustries(t);
  return <section className="py-24 bg-slate-50 border-t border-slate-200" data-id="element-203">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-204">
        <div className="text-center mb-16" data-id="element-205">
          <motion.h2 className="text-3xl md:text-4xl font-extrabold text-navy mb-4" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-206">
            {t('ind_title')}
          </motion.h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6" data-id="element-207">
          {industries.map((industry, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="group bg-white p-6 rounded-xl border border-slate-200 flex flex-col items-center justify-center text-center hover:border-electric hover:shadow-md transition-all cursor-pointer" data-id="element-208">
              <industry.icon className="w-10 h-10 text-slate-400 group-hover:text-electric mb-4 transition-colors" strokeWidth={1.5} data-id="element-209" />
              <h3 className="font-semibold text-navy group-hover:text-electric transition-colors" data-id="element-210">
                {industry.name}
              </h3>
            </motion.div>)}
        </div>
      </div>
    </section>;
}